// The Crewlinker web app has been retired. Instead of booting the full router /
// Relay / auth stack, we render a single static "service closed" notice for every
// visitor. The previous app entry (Sentry init, route table, Providers) is left
// out on purpose so no backend calls are made.
import { createRoot } from 'react-dom/client';
// components
import ClosedNotice from './ClosedNotice';
// styles
import 'index.css';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<ClosedNotice />);
